import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  effect,
  input,
  Output,
  untracked,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { FinoInputModule } from '@fino-ui/input';
import { TranslationModule } from '@fino-ui/translation';
import { Subscription, throttleTime } from 'rxjs';

@Component({
  selector: 'app-activate-product-switch',
  templateUrl: './activate-product-switch.component.html',
  styleUrl: './activate-product-switch.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslationModule,
    FinoInputModule,
  ],
})
export class ActivateProductSwitchComponent {
  isActive = input<boolean>(false);
  @Output() onActiveChanged = new EventEmitter<boolean>();

  form = new FormGroup({
    isProductActive: new FormControl(this.isActive()),
  });

  modelChangeSubscription: Subscription = Subscription.EMPTY;

  constructor() {
    this.listenToToggleChanges();
    // Watch for input changes
    effect(() => {
      const active = this.isActive();
      untracked(() => {
        // prevent from circular toggling the active toggle when model is programmitcally changed
        this.modelChangeSubscription.unsubscribe();
        this.form.setValue({
          isProductActive: active || false,
        });
        this.listenToToggleChanges();
      });
    });
  }

  listenToToggleChanges() {
    this.modelChangeSubscription = this.form.valueChanges
      .pipe(throttleTime(500))
      .subscribe((v) => {
        this.onActiveChanged.next(v.isProductActive);
      });
  }

  label = computed(
    () => `components.activate-product-switch.active.${this.isActive()}`,
  );
}
